import type { ReactNode } from 'react';
import { Ikon } from '../status/Ikon.tsx';

/**
 * «Om»-laget — nivå to av tre (`ux-flow-architect`, «Prosa har tre nivåer»;
 * UX-gjennomgangen 2026-09-14, B7).
 *
 * Nivå én er etiketten og hjelpeteksten: ÉN linje om hva feltet gjør. Nivå to er
 * regelen bak — takene, terskelene, hva systemet IKKE gjør — og den ligger her,
 * lukket til noen spør. Nivå tre er dokumentasjonen (produktsiden), som svarer på
 * hvorfor.
 *
 * Målt før: tre–fem setninger regel under hvert tallfelt på en flate produkteier
 * åpner hver dag. Regelen leses én gang og står i veien resten av året.
 *
 * `<details>` og ikke en egen tooltip: nettleseren gir tastaturbetjening, riktig
 * rolle for skjermleser, og treff på Ctrl+F inne i den lukkede teksten. Lukket er
 * standard — `open` settes aldri herfra.
 */
export function Om({ tittel, children, testid, sammendrag }: { tittel: string; children: ReactNode; testid?: string; /** Regelen i én linje ved siden av «Om …» — overskriften på det som folder seg ut, aldri en verdilinje (konseptets P9, rommet Hypoteser). Med den står pila i stedet for i-en. */ sammendrag?: string }) {
  if (sammendrag) {
    return (
      <details className="panel-om panel-om-linje" data-testid={testid}>
        <summary className="panel-om-sammendrag">
          <Ikon navn="chevron-forward-outline" className="panel-om-pil" />
          <b className="panel-om-tittel">Om {tittel}</b>
          <span className="panel-om-hint">· {sammendrag}</span>
        </summary>
        <div className="panel-om-innhold">{children}</div>
      </details>
    );
  }
  return (
    <details className="panel-om" data-testid={testid}>
      <summary className="panel-om-sammendrag">
        <Ikon navn="information-circle-outline" /> Om {tittel}
      </summary>
      <div className="panel-om-innhold">{children}</div>
    </details>
  );
}
